(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a.somna-mobile-cta, a.somna-final__button');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
})();
